module.exports = __webpack_public_path__ + "static/media/leonia.7b681184.png";